import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';

import { Link } from "react-router-dom";

import PriceList      from './PriceList'
import Quantity       from './Quantity'
import NewStoreButton from './NewStoreButton'

import { ReactComponent as Edit } from '../svg/edit.svg';

@inject('core')
@observer
export default class Product extends React.Component {
	
	constructor(props) {
		super(props)		
		this.editProduct = this.editProduct.bind(this)
	}

	componentDidMount() {
		const { core } = this.props	
	}
	
	editProduct() {
		const { core, product_id } = this.props
		
		var name = window.prompt('Product Name', core.products.find(p => p.product_id == product_id).name)
		if ((typeof name !== 'undefined') && (name !== null)) {
			
			if (
				(name == '') && 
				(window.confirm('Really delete the Product ' + core.products.find(p => p.product_id == product_id).name + '? This will also delete all prices associated with it.'))
			) {
				core.action({
					op: 'deleteProduct',
					product_id
				})
			}
			else if (name != '') {
				core.action({
					op:'updateProduct', 
					product_id, 
					name: name
				})				
			}
		}		
	}

	render() {
		const { core, product_id } = this.props

		const product = core.products.find(p => p.product_id == product_id)
		if (typeof product === 'undefined') {
			return <div>Unknown Product</div>
		}
		
		return <div>
			<h2>{product.name} <span className="update-button clickable" onClick={this.editProduct}>
			<Edit style={{width:'20px'}} />
			</span></h2>
				<Quantity product_id={product.product_id} />
				<PriceList product_id={product.product_id} />
				<NewStoreButton />
		</div>
	}
	
}


